











































































































































import { Component, Vue } from 'vue-property-decorator';
import { readUserProfile } from '@/store/main/getters';
import { dispatchGetFarms } from '@/store/farm/actions';
import FarmRequestRegistrationDialog from '@/components/FarmRequestRegistrationDialog.vue';
import FarmAuthorizationStatus from '@/components/FarmAuthorizationStatus.vue';
import {readFarms} from '@/store/farm/getters';

@Component({
    components: {FarmRequestRegistrationDialog},
})
export default class Dashboard extends Vue {
  public totalFarms: number = 0;
  public activeFarms: number = 0;
  public inactiveFarms: number = 0;
  public authorizedFarms: number = 0;
  public unauthorizedFarms: number = 0;

  public async mounted() {
      await dispatchGetFarms(this.$store);
      this.totalFarms = this.farms.length;
      this.activeFarms = this.farms.filter((farm) => farm.active).length;
      this.inactiveFarms = this.farms.filter((farm) => !farm.active).length;
      this.authorizedFarms = this.farms.filter((farm) => farm.active && farm.is_authorized).length;
      this.unauthorizedFarms = this.farms.filter((farm) => farm.active && !farm.is_authorized).length;
  }

  get farms() {
      return readFarms(this.$store);
  }

  get greetedUser() {
    const userProfile = readUserProfile(this.$store);
    if (userProfile && userProfile.full_name) {
      if (userProfile.full_name) {
        return userProfile.full_name;
      } else {
        return userProfile.email;
      }
    }
  }
}
